import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';
import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';
import Tooltip from 'elements/Tooltip/Tooltip';
import { ListElement } from 'elements/Tooltip/Layout';

import styles from './IconCard.css';

const IconCard = ({ icon }) => {
  const cx = classnames.bind(styles);

  return (
    <li className={styles.wrapper}>
      <CopyToClipboard
        dataText={`<Icon icon={'${icon.name}'} type={'${icon.type}'} />`}
        render={
          (copied) =>
            <div className={cx('preview', { 'active': copied })}>
              <div className={styles.icon}>
                <Icon icon={icon.name} type={icon.type} customClasses={styles.appIcon} />
                <Tooltip
                  target={
                    <Icon
                      icon={copied ? 'confirmation' : 'duplicate'}
                      type={'20'}
                      customClasses={cx('copyIcon', { 'active': copied })} />
                  }
                  open={copied}
                  placement={'top'}
                >
                  <ListElement>Icon Copied!</ListElement>
                </Tooltip>
              </div>
            </div>
        }
      />
      <div className={styles.details}>
        <p className={classnames(styles.name, 'small')}>{icon.name}</p>
        <p className={classnames(styles.size, 'tag')}>{icon.size}</p>
      </div>
    </li>
  );
};

IconCard.propTypes = {
  icon: PropTypes.object.isRequired
};

IconCard.displayName = 'IconCard';

export default IconCard;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/IconCard/IconCard.js